if(document.querySelector("#showhideDetail")){
  document.querySelector("#showhideDetail").parentElement.style.display = "flex";
  document.getElementById("showhideDetail").innerHTML = `<svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 9-7 7-7-7"/>
</svg>`;
  document.querySelector("#showhideDetail").addEventListener("click",()=>{
        if(document.getElementById("detailfit").style.display != "block"){
        document.getElementById("detailfit").style.display = "block";
        document.getElementById("showhideDetail").innerHTML = `<svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m5 15 7-7 7 7"/>
</svg>
`;
        }else{
        document.getElementById("detailfit").style.display = "none";
        document.getElementById("showhideDetail").innerHTML = `<svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 9-7 7-7-7"/>
</svg>`;  
        }
    })
}

